export default __webpack_public_path__ + "static/media/icon-cashback-warning.ba6a5a1b.svg";